module.exports = __webpack_public_path__ + "static/media/crm-auth-reset-password-confirm-succeed-image.afb4b231.svg";